/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_Empty_EventInputs */

const en_video_export_preview_empty_event = /** @type {(inputs: Video_Export_Preview_Empty_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empty event`)
};

const fr_video_export_preview_empty_event = /** @type {(inputs: Video_Export_Preview_Empty_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenement vide`)
};

const de_video_export_preview_empty_event = /** @type {(inputs: Video_Export_Preview_Empty_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leeres Ereignis`)
};

const it_video_export_preview_empty_event = /** @type {(inputs: Video_Export_Preview_Empty_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento vuoto`)
};

const ru_video_export_preview_empty_event = /** @type {(inputs: Video_Export_Preview_Empty_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пустое событие`)
};

const es_video_export_preview_empty_event = /** @type {(inputs: Video_Export_Preview_Empty_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento vacío`)
};

const zh_cn2_video_export_preview_empty_event = /** @type {(inputs: Video_Export_Preview_Empty_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空事件`)
};

const ja_video_export_preview_empty_event = /** @type {(inputs: Video_Export_Preview_Empty_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空のイベント`)
};

const hi_video_export_preview_empty_event = /** @type {(inputs: Video_Export_Preview_Empty_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाली घटना`)
};

const pt_pt2_video_export_preview_empty_event = /** @type {(inputs: Video_Export_Preview_Empty_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento vazio`)
};

/**
* | output |
* | --- |
* | "Empty event" |
*
* @param {Video_Export_Preview_Empty_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_empty_event = /** @type {((inputs?: Video_Export_Preview_Empty_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_Empty_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preview_empty_event(inputs)
	if (locale === "de") return de_video_export_preview_empty_event(inputs)
	if (locale === "it") return it_video_export_preview_empty_event(inputs)
	if (locale === "ru") return ru_video_export_preview_empty_event(inputs)
	if (locale === "es") return es_video_export_preview_empty_event(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preview_empty_event(inputs)
	if (locale === "ja") return ja_video_export_preview_empty_event(inputs)
	if (locale === "hi") return hi_video_export_preview_empty_event(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preview_empty_event(inputs)
	return en_video_export_preview_empty_event(inputs)
});